import { tz, type TZDate } from '@date-fns/tz';
import { isValid, parse, parseISO } from 'date-fns';
import { toISODateFormat } from './dateFormatters';

/**
 * @param date e.g., '2022-03-10'
 * @param time e.g., '09:00:00' <- Don't forget the leading zero!
 * @param timeZone e.g., 'America/New_York'
 */
export const zonedDateTime = (
  date: string,
  time: string,
  timeZone: string,
): TZDate => parseISO(`${date}T${time}`, { in: tz(timeZone) });

/**
 * Reverses `toEventUrlDateFormat` -- parses the event ticket purchase page's
 * URL date segment back into an ISO date for querying the API.
 * Returns '' for malformed date segments.
 *
 * @param date e.g., '24-12-2026'
 * @example '2026-12-24'
 */
export const parseEventUrlDate = (date: string): string => {
  const parsedDate = parse(date, 'dd-MM-yyyy', new Date());
  return isValid(parsedDate) ? toISODateFormat(parsedDate) : '';
};
